import { multiStep } from '../MultiStepWizard/multiStep'
import { Values } from 'components/Wizards/MultiStepBlogPostWizard/Types'
import { Step } from '../MultiStepWizard/Step'
import { StepProps } from '../MultiStepWizard/Types'
import { useGenerateTitleOptions } from './useGenerateTitleOptions'
import { useImages, useUnsplashImages } from 'components/Wizards/SelectImages/ImagesProvider'

export const FirstStep = multiStep(({ onSubmit, ...props }: StepProps) => {
  const generateTitles = useGenerateTitleOptions({ onCancel: props.onBack })
  const { generateImageKeywords, topic } = useImages()
  const { clearPhotos, setPage } = useUnsplashImages()

  const handleSubmit = (values: Values) => {
    generateTitles(values)
    if (topic !== values.topic) {
      clearPhotos()
      setPage(1)
      generateImageKeywords(values)
    }
    return onSubmit({ ...values })
  }

  return <Step {...props} onSubmit={handleSubmit} />
})
